import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
  getAllReviews,
  createReview,
  getSingleReview,
  updateReview,
  deleteReview
} from '@/api/online-ordering/settings/review'


export const fetchAllReviews = createAsyncThunk(
  'reviews/fetchAll',
  async (restaurantId, { rejectWithValue }) => {
    const response = await getAllReviews(restaurantId)
    if (response.status === 'success') return response.data.reviews
    return rejectWithValue(response.message)
  }
)

export const createNewReview = createAsyncThunk(
  'reviews/create',
  async (data, { rejectWithValue }) => {
    const response = await createReview(data)
    if (response.status === 'success') return response.data.review
    return rejectWithValue(response.message)
  }
)

export const fetchSingleReview = createAsyncThunk(
  'reviews/fetchOne',
  async (id, { rejectWithValue }) => {
    const response = await getSingleReview(id)
    if (response.status === 'success') return response.data.review
    return rejectWithValue(response.message)
  }
)

export const updateExistingReview = createAsyncThunk(
  'reviews/update',
  async ({ id, data }, { rejectWithValue }) => {
    const response = await updateReview(id, data)
    if (response.status === 'success') return response.data.review
    return rejectWithValue(response.message)
  }
)

export const deleteReviewById = createAsyncThunk(
  'reviews/delete',
  async (id, { rejectWithValue }) => {
    const response = await deleteReview(id)
    if (response.status === 'success') return id
    return rejectWithValue(response.message)
  }
)

const reviewSlice = createSlice({
  name: 'reviews',
  initialState: {
    reviews: [],
    singleReview: {},
    getLoading: false,
    createLoading: false,
    updateLoading: false,
    deleteLoading: false,
    error: null
  },
  reducers: {
    clearReviewState (state) {
      state.error = null
      state.getLoading = false
      state.createLoading = false
      state.updateLoading = false
      state.deleteLoading = false
      ;(state.singleReview = {}), (state.reviews = [])
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchAllReviews.pending, state => {
        state.getLoading = true
        state.error = null
      })
      .addCase(fetchAllReviews.fulfilled, (state, action) => {
        state.getLoading = false
        state.reviews = action.payload
      })
      .addCase(fetchAllReviews.rejected, (state, action) => {
        state.getLoading = false
        state.error = action.payload
      })
      .addCase(createNewReview.pending, state => {
        state.createLoading = true
        state.error = null
      })
      .addCase(createNewReview.fulfilled, (state, action) => {
        state.createLoading = false
        state.reviews.push(action.payload)
      })
      .addCase(createNewReview.rejected, (state, action) => {
        state.createLoading = false
        state.error = action.payload
      })
      .addCase(fetchSingleReview.pending, state => {
        state.getLoading = true
        state.error = null
      })
      .addCase(fetchSingleReview.fulfilled, (state, action) => {
        state.getLoading = false
        state.singleReview = action.payload
      })
      .addCase(fetchSingleReview.rejected, (state, action) => {
        state.getLoading = false
        state.error = action.payload
      })
      .addCase(updateExistingReview.pending, state => {
        state.updateLoading = true
        state.error = null
      })
      .addCase(updateExistingReview.fulfilled, (state, action) => {
        state.updateLoading = false
        const index = state.reviews.findIndex(
          review => review.id === action.payload.id
        )
        if (index !== -1) {
          state.reviews[index] = action.payload
        }
      })
      .addCase(updateExistingReview.rejected, (state, action) => {
        state.updateLoading = false
        state.error = action.payload
      })
      .addCase(deleteReviewById.pending, state => {
        state.deleteLoading = true
        state.error = null
      })
      .addCase(deleteReviewById.fulfilled, (state, action) => {
        state.deleteLoading = false
        state.reviews = state.reviews.filter(
          review => review.id !== action.payload
        )
      })
      .addCase(deleteReviewById.rejected, (state, action) => {
        state.deleteLoading = false
        state.error = action.payload
      })
  }
})

export const { clearReviewState } = reviewSlice.actions
export default reviewSlice.reducer
